async function flash_sale_add_cart(element){
    const loadingDom = element.querySelector(".loading-overlay__spinner");
    if(loadingDom){
      loadingDom.classList.remove("hidden");
      setTimeout(() => {
        loadingDom.classList.add("hidden");
      }, 5000);
    }
    const form = element.form;
    const formData = new FormData(form);
    console.log("formData",formData);
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    
    if (response.ok) {
      updateCartSection();
    } else {
      const error = await response.json();
      cosnole.log(error.message);
    }
    return false;
}

function updateCartSection(){
  fetch('/cart.js', { method: 'POST' })
    .then(response => response.text())
    .then(html => {
      let bubble = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector("#cart-icon-bubble");
      document.querySelector("#cart-icon-bubble").innerHTML = bubble.innerHTML;
      let drawer = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector("cart-drawer.drawer");
      document.querySelector("cart-drawer.drawer").outerHTML = drawer.outerHTML;
      document.querySelector(".cart__contents").style.display="block";

      document.querySelector("#cart-icon-bubble").click();
    });
}

function toLink(handle){
  window.location.href = `/products/${handle}`;
}